import { createSelector } from 'reselect';
import Immutable from 'immutable';
import { selectSingularUGCByUsers, selectSingularUGCForCurrentUser } from './UGCBaseSelector';

const getTransactions = state => state.getIn(['ugc', 'ageSuitabilitiesTransactions'], Immutable.Map());

export const selectAgeSuitabilitiesByUsers = selectSingularUGCByUsers('ageSuitabilities');

export const selectAgeSuitabilitiesTransactions = createSelector([getTransactions], transactions => transactions);

export const selectCurrentUserAgeSuitabilities = selectSingularUGCForCurrentUser('ageSuitabilities');

export default {
  selectAgeSuitabilitiesByUsers,
  selectAgeSuitabilitiesTransactions,
  selectCurrentUserAgeSuitabilities
};
